import { WellnessWheelArcProps } from "../types";

export default function InfoCategory({ arcColorFill }: WellnessWheelArcProps) {
  return (
    <path
      d="M139.51 27.2812C108.695 27.2812 80.8127 39.6466 60.6973 59.6147"
      stroke={arcColorFill}
      strokeWidth="50.521"
      strokeLinecap="round"
      style={{
        strokeDasharray: 1000,
        strokeDashoffset: -1000,
        animation: "drawArcReverse 0.5s ease-out 2s forwards",
      }}
    />
  );
}
